export default function inMinutes() {
  return function(input) {
    const parsedValue = parseInt(input);
    const minutes = Math.round(parsedValue / 60);
    let seconds = parsedValue % 60;
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    return `${minutes}:${seconds}`;
  }
};



// WEBPACK FOOTER //
// ./src/app/screens/engineer/util/in-minutes.filter.js